import './index.css';

const BookingComplete = ({ renderComplete }) => (
  renderComplete()
)

export default BookingComplete;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingComplete.js